import React from 'react';
import { splitPercentParts } from '../../utils/rankingDisplay';

interface RankingHighlightedTextProps {
  text: string;
  className?: string;
}

const RankingHighlightedText: React.FC<RankingHighlightedTextProps> = ({ text, className }) => {
  const parts = splitPercentParts(text);

  return (
    <span className={className}>
      {parts.map((part, index) =>
        part.type === 'percent' ? (
          <span key={index} className="ranking-pct">
            {part.value}
          </span>
        ) : (
          <React.Fragment key={index}>{part.value}</React.Fragment>
        )
      )}
    </span>
  );
};

export default RankingHighlightedText;
